import { DevicesManagerService } from '../services/devices-manager.service';
import { PreferenceService } from '../services/preference.service';
import { Attribute, CoyoteWS } from './Attribute';

export const DEVICE_STATUS = {
  fullyStopped: {
    text: 'A l’arrêt (contact éteint)',
    value: 'fullyStopped',
  },
  stopped: {
    text: 'A l’arrêt (contact allumé)',
    value: 'stopped',
  },
  moving: {
    text: 'En déplacement',
    value: 'moving',
  },
  inactive: {
    text: 'inactive',
    value: 'inactive',
  },
} as const;

export const DEVICES_HAS_CAN = ['QL350CEU'];
export const DEVICES_HAS_BEACON = 'BEACON';
export const BLUR_BEACON = 100;
export class Device {
  private _registration: string;
  public address: string;
  public attributes: string;
  public normalizeAttributes: Attribute[];
  public available: boolean;
  public battery_last_timestamp: number;
  public battery_level: null | number;
  public battery_volt: null | number;
  public course: number;
  public csq: number;
  public dev_hw_id: string;
  public device_log: number;
  public device_type: number; // 0: vehicule, 1: engin
  public driver_name: string;
  public driver_phone: string;
  public engine: number;
  public first_day_trip: number;
  public gps_sat_used: number;
  public hardware: string;
  public hdop: number;
  public icon: string;
  public iconPosition: number;
  public id_symbol: number;
  public input: number;
  public isBlurHdop: boolean;
  public isLocked: boolean;
  public isPrivacy: boolean;
  public isWaitingCommand: boolean;
  public keywords: string;
  public last_data_timestamp: number;
  public last_trip_start: number;
  public last_trip_stop: number;
  public latitude: number;
  public location_date: number;
  public locking_request_created: number;
  public locking_request_status: string;
  public locking_request_successed_type: string;
  public locking_request_type: string;
  public longitude: number;
  public mileage: number;
  public movingStatus: (typeof DEVICE_STATUS)[keyof typeof DEVICE_STATUS] = DEVICE_STATUS.inactive;
  public new_status: number;
  public pda: string;
  public poi: number;
  public serial_number: string;
  public shipping_code: string;
  public snexternal: string;
  public soh: '1_OK' | '2_Warning' | '3_BigWarning' | '4_KO';
  public special_flag: number;
  public speed_current: number;
  public speed_max: number;
  public status_lock: string;
  public status: number;
  public summary: string;
  public temperature: number;
  public uid_driver: number;
  public uid_parent: number;
  public uid_picture: number;
  public uid_pictures: number[];
  public uid_zoi: number;
  public uid: number;
  public vin: number;
  public coyoteWS: CoyoteWS | null;
  public newStatus: 0 | 1 | 2 | 3;
  public deviceStatusClass: string;
  public anomalyError: 'GPS_TRANS_ANOMALY' | 'GPS_ANOMALY' | 'TRANSMISSION_ANOMALY' | 'ANOMALY_BEACON' | null;

  public fk_asset: number | null;
  public weight: number;
  public batteryLevelIcon: string;

  public constructor(deviceBack?) {
    this.uid_parent = deviceBack?.uid_parent;
    this.address = deviceBack?.address;
    this.battery_level = deviceBack?.battery_level;
    this.course = deviceBack?.course;
    this.device_log = deviceBack?.device_log;
    this.uid_driver = Number(deviceBack?.uid_driver);
    this.driver_name = deviceBack?.driver_name;
    this.driver_phone = deviceBack?.driver_phone;
    this.first_day_trip = deviceBack?.first_day_trip;
    this.gps_sat_used = deviceBack?.gps_sat_used;
    this.csq = deviceBack?.csq;
    this.hdop = deviceBack?.hdop > 32768 ? deviceBack?.hdop * 10 : deviceBack?.hdop; //meters
    this.input = deviceBack?.input;
    this.last_data_timestamp = deviceBack?.last_data_timestamp;
    this.last_trip_start = deviceBack?.last_trip_start;
    this.last_trip_stop = deviceBack?.last_trip_stop;
    this.latitude =
      deviceBack?.latitude !== undefined && deviceBack?.latitude !== null && deviceBack?.latitude !== 0
        ? deviceBack?.latitude
        : null;
    this.location_date = deviceBack?.location_date;
    this.longitude =
      deviceBack?.longitude !== undefined && deviceBack?.longitude !== null && deviceBack?.longitude !== 0
        ? deviceBack?.longitude
        : null;
    this._registration = !deviceBack?.registration ? deviceBack?.uid + '' : deviceBack?.registration;
    this.special_flag = deviceBack?.special_flag;
    this.speed_current = deviceBack?.speed_current;
    this.speed_max = deviceBack?.speed_max;
    this.status = deviceBack?.status === 0 ? 1 : deviceBack?.status;
    this.summary = deviceBack?.summary;
    this.uid = deviceBack?.uid;
    this.dev_hw_id = deviceBack?.dev_hw_id;
    this.hardware = deviceBack?.hardware;
    this.device_type = deviceBack?.device_type;
    this.uid_picture = deviceBack?.uid_picture;
    this.poi = deviceBack?.poi;
    this.uid_zoi = deviceBack?.uid_zoi;
    this.available = deviceBack?.available;
    this.keywords = deviceBack?.keywords;
    this.temperature = deviceBack?.temperature;
    this.id_symbol = deviceBack?.id_symbol;
    this.mileage = deviceBack?.mileage;
    this.engine = deviceBack?.engine;
    this.serial_number = deviceBack?.serial_number;
    this.battery_volt = deviceBack?.battery_volt;
    this.battery_last_timestamp = deviceBack?.battery_last_timestamp;
    this.pda = deviceBack?.pda;
    this.locking_request_status = deviceBack?.locking_request_status;
    this.locking_request_type = deviceBack?.locking_request_type;
    this.locking_request_created = deviceBack?.locking_request_created;
    this.locking_request_successed_type = deviceBack?.locking_request_successed_type;
    this.shipping_code = deviceBack?.shipping_code;
    this.snexternal = deviceBack?.snexternal;
    this.fk_asset = deviceBack?.fk_asset;
    DevicesManagerService.setAttributes(deviceBack);
    DevicesManagerService.setStatusDevice(this);
    DevicesManagerService.setStatusLock(this);
    this.uid_pictures =
      Array.isArray(deviceBack?.uid_pictures) && deviceBack?.uid_pictures?.length > 0
        ? deviceBack.uid_pictures
        : deviceBack?.uid_pictures?.split(',').map(Number);
    this.batteryLevelIcon = deviceBack?.soh ? this.setBatteryLevel(deviceBack?.soh) : undefined;
    this.soh = deviceBack.soh;
    this.vin = deviceBack?.vin;
    this.isBlurHdop = deviceBack?.hdop > 100;
    this.isPrivacy = this.hasPrivacy();
    this.normalizeAttributes = deviceBack.normalizeAttributes;
    this.anomalyError = DevicesManagerService.getAnomalyError(this);
  }

  public get hasCAN() {
    return DEVICES_HAS_CAN.includes(this.hardware);
  }

  get hasBeacon() {
    return this.hardware === DEVICES_HAS_BEACON;
  }

  private setBatteryLevel(value: '1_OK' | '2_Warning' | '3_BigWarning' | '4_KO') {
    switch (value) {
      case '1_OK':
        return 'signal_cellular_alt';
      case '2_Warning':
        return 'signal_cellular_alt_2_bar';
      case '3_BigWarning':
        return 'signal_cellular_alt_1_bar';
      case '4_KO':
        return 'signal_cellular_alt_1_bar';
      default:
        return value;
    }
  }

  //** Temporary solution to not call the getElement of storageService, is too greedy */
  private static preferenceService: PreferenceService;

  static injectService(service: PreferenceService) {
    this.preferenceService = service;
  }

  public set registration(value: string) {
    this._registration = value;
  }

  public get registration() {
    const isUrlEdit = window.location.href.includes('deviceedit');
    if (isUrlEdit) return this._registration;
    switch (Device.preferenceService?.$preference()?.config?.deviceView) {
      case 'snexternal':
        return this.snexternal ? this.snexternal : this._registration;
      case 'vin':
        return this.vin ? this.vin.toString() : this._registration;
      case 'summary':
        return this.summary ? this.summary : this._registration;
      case 'registration':
        return this._registration;
      default:
        return this._registration;
    }
  }

  /**
   * Returns the initial registration (used for fuel card import)
   */
  public get initialRegistration() {
    return this._registration;
  }

  public attributesJson(): string {
    return JSON.stringify({ attributes: this.attributes });
  }

  /**
   * Get if the current state of device is privacy or not
   */
  public hasPrivacy() {
    return (this.special_flag & 2) !== 0;
  }

  public get duplicateDeviceUid() {
    return this.uid;
  }

  public get keywordList() {
    return !!this.keywords && this.keywords !== '' ? this.keywords.split(',').map(Number) : [];
  }
}
